import { gql } from '@apollo/client'
import PAGINATED_PAGE_INFO_FRAGMENT from 'apollo/fragments/PAGINATED_PAGE_INFO_FRAGMENT'

// ACTIVE_CARE_PLAN_DRAFTS

export default gql`
  query active_care_plan_drafts(
    $filters: TicketFilterInput
    $order: TICKET_ORDER
    $order_scope: TICKET_ORDER_SCOPE
    $cursor: String
  ) {
    tickets(
      filters: $filters
      after: $cursor
      order: $order
      order_scope: $order_scope
      first: 10
    ) {
      nodes {
        resource {
          ... on RoadmapV2 {
            id
            state
            title
            performed_by
            preferred_address
            preferred_distance
          }
        }
        member {
          id
          first_name
          last_name
        }
      }
      pageInfo {
        ...PAGINATED_PAGE_INFO_FRAGMENT
      }
    }
  }
  ${PAGINATED_PAGE_INFO_FRAGMENT}
`
